/** AsyncStorage: user finished or skipped the post-onboarding app tour (shown once). */
export const POST_ONBOARDING_APP_TOUR_DONE_KEY = '@smartsaas_post_onboarding_app_tour_v1_done';

/** Brief pause after onboarding ends so other RN modals / layout can settle before the tour mounts. */
export const POST_ONBOARDING_TOUR_OPEN_DELAY_MS = 450;

/** Default native drawer width for spotlight fallback (see DashStack.native `drawerWidthPx`). */
export const POST_ONBOARDING_TOUR_NATIVE_DRAWER_DEFAULT_PX = 230;

/** 0-based step indices (aligned with PostOnboardingAppTourModal `steps` array). */
export const POST_ONBOARDING_TOUR_MENU_STEP_INDEX = 1;

/**
 * Native DashStack: honor OPEN_MENU / MENU_OPEN while the tour is visible only on this step
 * (drawer demo). Kept in sync with {@link POST_ONBOARDING_TOUR_MENU_STEP_INDEX}.
 */
export const POST_ONBOARDING_TOUR_DRAWER_DEMO_STEP_INDEX: number | null =
  POST_ONBOARDING_TOUR_MENU_STEP_INDEX;

export const POST_ONBOARDING_TOUR_MESSAGES_STEP_INDEX = 2;
/** “Status bar / tap robot / Easy Mode” (tour order after messages). */
export const POST_ONBOARDING_TOUR_EASY_MODE_HIGHLIGHT_STEP_INDEX = 3;
export const POST_ONBOARDING_TOUR_PROACTIVE_STEP_INDEX = 4;
export const POST_ONBOARDING_TOUR_TOP_LEFT_STEP_INDEX = 5;
export const POST_ONBOARDING_TOUR_TOP_RIGHT_STEP_INDEX = 6;
/** Status bar home: one tap home, double-tap menu (native). */
export const POST_ONBOARDING_TOUR_HOME_BUTTON_STEP_INDEX = 7;
export const POST_ONBOARDING_TOUR_SHARE_STEP_INDEX = 8;
export const POST_ONBOARDING_TOUR_AGENT_LOG_STEP_INDEX = 9;

/** DOM ids for web spotlight measurement (first match wins per group). */
export const POST_ONBOARDING_TOUR_WEB_ELEMENT_IDS = {
  menu: ['tutorial-menu-button'] as const,
  company: ['tutorial-company-selector'] as const,
  easyMode: ['tutorial-easy-mode-toggle'] as const,
  proactive: ['tutorial-easy-mode-toggle'] as const,
  home: ['tutorial-home-button'] as const,
  messaging: ['tutorial-messaging-cluster', 'tutorial-status-bar-right'] as const,
  topRight: ['tutorial-status-bar-right', 'tutorial-messaging-cluster'] as const,
  share: ['tutorial-share-qr', 'tutorial-easy-mode-toggle'] as const,
  agentLog: ['tutorial-easy-mode-toggle'] as const,
};
